import React from 'react';
import Button from '@amzn/meridian/button';
import Tooltip from '@amzn/meridian/tooltip';
import PropTypes from 'prop-types';
import { SUBMIT_BUTTON_PROPERTIES } from '../constants/FeedbackConstants';

const ButtonWithToolTip = ({
  onClickFooterButton,
  title,
  submitButtonSize,
  submitButtonType,
  submitButtonText,
}) => {
  return (
    <>
      <Tooltip position="right" title={title}>
        <span>
          <Button
            type={submitButtonType}
            size={submitButtonSize}
            disabled
            onClick={onClickFooterButton}>
            {submitButtonText}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};

ButtonWithToolTip.propTypes = {
  onClickFooterButton: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  submitButtonSize: PropTypes.string,
  submitButtonType: PropTypes.string,
  submitButtonText: PropTypes.string,
};

ButtonWithToolTip.defaultProps = {
  submitButtonSize: SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: SUBMIT_BUTTON_PROPERTIES.text,
};

export default ButtonWithToolTip;
